"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EspoolChainPosition = void 0;
var EspoolChainPosition;
(function (EspoolChainPosition) {
    EspoolChainPosition["linear"] = "linear";
    EspoolChainPosition["left"] = "left";
    EspoolChainPosition["right"] = "right";
})(EspoolChainPosition = exports.EspoolChainPosition || (exports.EspoolChainPosition = {}));
//# sourceMappingURL=EspoolChainPosition.js.map